module.exports = __webpack_public_path__ + "img/people_cll.d43a4825.png";